import {
  AndConditionInput as GeneratedAndConditionInput,
  ContainsConditionInput as GeneratedContainsConditionInput,
  IsInConditionInput as GeneratedIsInConditionInput,
  ContainsConditionInputTypeEnum,
  EqualsConditionInput as GeneratedEqualsConditionInput,
  EqualsConditionInputTypeEnum,
  GreaterThanConditionInput as GeneratedGreaterThanConditionInput,
  GreaterThanConditionInputTypeEnum,
  GreaterThanOrEqualsConditionInput as GeneratedGreaterThanOrEqualsConditionInput,
  GreaterThanOrEqualsConditionInputTypeEnum,
  IsNullConditionInput as GeneratedIsNullConditionInput,
  LessThanConditionInput as GeneratedLessThanConditionInput,
  LessThanConditionInputTypeEnum,
  LessThanOrEqualsConditionInput as GeneratedLessThanOrEqualsConditionInput,
  LessThanOrEqualsConditionInputTypeEnum,
  NotConditionInput as GeneratedNotConditionInput,
  NotConditionInputTypeEnum,
  OrConditionInput as GeneratedOrConditionInput,
  AbsoluteTimePoint,
  RelativeTimePoint,
  AbsoluteTimePointTypeEnum,
  RelativeTimePointTypeEnum,
  EntityPropertyRef,
  FeatureRef,
  EntityPropertyRefTypeEnum,
  FeatureRefTypeEnum,
  SourcePreviewData,
  DecisionEnvironment,
  Literal,
  LiteralTypeEnum,
  IsNullConditionInputTypeEnum,
  IsInConditionInputTypeEnum,
  GetEntityCountResponse,
} from "src/clients/jobs";

export type OperandTypes =
  | AbsoluteTimePointTypeEnum.TIME_POINT_ABSOLUTE
  | RelativeTimePointTypeEnum.TIME_POINT_RELATIVE
  | EntityPropertyRefTypeEnum.ENTITY_PROPERTY_REF
  | FeatureRefTypeEnum.FEATURE_REF;

export type Lhs = (EntityPropertyRef | FeatureRef) & { id: string };

export type Rhs =
  | ({ type: LiteralTypeEnum.LITERAL } & Literal)
  | ({
      type: AbsoluteTimePointTypeEnum.TIME_POINT_ABSOLUTE;
    } & AbsoluteTimePoint)
  | ({
      type: RelativeTimePointTypeEnum.TIME_POINT_RELATIVE;
    } & RelativeTimePoint);

export const operatorsList = [
  IsInConditionInputTypeEnum.IS_IN,
  ContainsConditionInputTypeEnum.CONTAINS,
  EqualsConditionInputTypeEnum.EQ,
  GreaterThanConditionInputTypeEnum.GT,
  GreaterThanOrEqualsConditionInputTypeEnum.GTE,
  IsNullConditionInputTypeEnum.IS_NULL,
  LessThanConditionInputTypeEnum.LT,
  LessThanOrEqualsConditionInputTypeEnum.LTE,
  NotConditionInputTypeEnum.NOT,
] as const;

export type Operators =
  | IsInConditionInputTypeEnum.IS_IN
  | ContainsConditionInputTypeEnum.CONTAINS
  | EqualsConditionInputTypeEnum.EQ
  | GreaterThanConditionInputTypeEnum.GT
  | GreaterThanOrEqualsConditionInputTypeEnum.GTE
  | IsNullConditionInputTypeEnum.IS_NULL
  | LessThanConditionInputTypeEnum.LT
  | LessThanOrEqualsConditionInputTypeEnum.LTE
  | NotConditionInputTypeEnum.NOT;

type ContainsConditionInput = {
  type: GeneratedContainsConditionInput["type"];
  lhs: Lhs;
  rhs: Rhs;
};

type IsInConditionInput = {
  type: GeneratedIsInConditionInput["type"];
  lhs: Lhs;
  rhs: Rhs;
};

type EqualsConditionInput = {
  type: GeneratedEqualsConditionInput["type"];
  lhs: Lhs;
  rhs: Rhs;
};

type GreaterThanConditionInput = {
  type: GeneratedGreaterThanConditionInput["type"];
  lhs: Lhs;
  rhs: Rhs;
};

type GreaterThanOrEqualsConditionInput = {
  type: GeneratedGreaterThanOrEqualsConditionInput["type"];
  lhs: Lhs;
  rhs: Rhs;
};

type LessThanOrEqualsConditionInput = {
  type: GeneratedLessThanOrEqualsConditionInput["type"];
  lhs: Lhs;
  rhs: Rhs;
};

type LessThanConditionInput = {
  type: GeneratedLessThanConditionInput["type"];
  lhs: Lhs;
  rhs: Rhs;
};

type NotConditionInput = {
  type: GeneratedNotConditionInput["type"];
  condition: ConditionWithoutNot;
};

type IsNullConditionInput = {
  type: GeneratedIsNullConditionInput["type"];
  lhs: Lhs;
  rhs: Rhs;
};

// original generated types are AndOrConditionInputConditionsInner
export type Condition =
  | ({ type: IsInConditionInputTypeEnum.IS_IN } & IsInConditionInput)
  | ({ type: ContainsConditionInputTypeEnum.CONTAINS } & ContainsConditionInput)
  | ({ type: EqualsConditionInputTypeEnum.EQ } & EqualsConditionInput)
  | ({ type: GreaterThanConditionInputTypeEnum.GT } & GreaterThanConditionInput)
  | ({
      type: GreaterThanOrEqualsConditionInputTypeEnum.GTE;
    } & GreaterThanOrEqualsConditionInput)
  | ({ type: IsNullConditionInputTypeEnum.IS_NULL } & IsNullConditionInput)
  | ({ type: LessThanConditionInputTypeEnum.LT } & LessThanConditionInput)
  | ({
      type: LessThanOrEqualsConditionInputTypeEnum.LTE;
    } & LessThanOrEqualsConditionInput)
  | ({ type: NotConditionInputTypeEnum.NOT } & NotConditionInput);

export type ConditionWithoutNot = Exclude<
  Condition,
  { type: NotConditionInputTypeEnum.NOT }
>;

export type UnaryCondition =
  | {
      type: ConditionWithoutNot["type"];
      value: Lhs;
    }
  | {
      type: NotConditionInputTypeEnum.NOT;
      condition: UnaryCondition;
    };

type AndConditionGroup = {
  type: GeneratedAndConditionInput["type"];
  conditions: Condition[];
};

type OrConditionGroup = {
  type: GeneratedOrConditionInput["type"];
  conditions: Condition[];
};

type AndConditionGroups = {
  type: GeneratedAndConditionInput["type"];
  conditions: AndConditionGroup[];
};

type OrConditionGroups = {
  type: GeneratedOrConditionInput["type"];
  conditions: OrConditionGroup[];
};

export type FormData = {
  filter_condition: AndConditionGroups | OrConditionGroups;
};

export type SourcePreviewDataConfig = {
  environment: DecisionEnvironment;
  data: SourcePreviewData;
};

export type SourceCountDataConfig = {
  isPending: boolean;
  data?: GetEntityCountResponse;
};

export type FieldErrors = { [key: string]: string } | undefined;
